import styles from "./app.module.scss"
import {Suspense} from "react";
import {useRoutes} from "react-router-dom";
import routes from "./routes";
import LoadingPage from "./pages/loading";
import dayjs from "dayjs";
import 'dayjs/locale/zh-cn';

dayjs.locale('zh-cn');

function App() {
    const Views = () => useRoutes(routes);

    return (
        <Suspense fallback={<LoadingPage/>}>
            <div className={styles.App}>
                <Views/>
            </div>
        </Suspense>
    );
}

export default App;
